/** Import react/libraries section **/
import React from 'react';
import { Link } from 'react-router-dom';

/** Import helpers section **/

/** Import styles section **/
import './ChangePasswordRequestStyles.scss';

/** Import resources section **/
import { Button, Paper } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

/** Import services section **/

/** Import component section **/
import MUITextField from '../../components/inputs/MUITextField';

const ChangePasswordRequestView = ({
  email,
  onEmailChange,
  validEmail,
  requested,
  inProcess,
  successRequest,
  onSubmit,
  onResetRequest
}) => {
  const requestView = () => {
    return (
      <>
        <div className="changepasswordreq_container_form">
          <MUITextField
            label="Ingresa tu dirección de correo"
            id="email"
            name="email"
            value={email}
            type="text"
            onChange={onEmailChange}
          />
        </div>
        <Button
          className="changepasswordreq_container_button"
          onClick={onSubmit}
          disabled={!validEmail}
        >
          {inProcess === true ? 'Solicitando' : 'Solicitar'}
        </Button>
        <div className="changepasswordreq_container_success_link ">
          <Link to="/">
            <ArrowBackIosIcon /> Regresar a login
          </Link>
        </div>
      </>
    );
  };

  const errorView = () => {
    return (
      <>
        <div className="changepasswordreq_container_error">
          <div className="changepasswordreq_container_error_text">
            Problema inesperado con el sistema.
          </div>
        </div>
        <Button
          className="changepasswordreq_container_button"
          onClick={onResetRequest}
        >
          Reintentar?
        </Button>
      </>
    );
  };

  const viewToShow = () => {
    if (requested && !successRequest) {
      return errorView();
    }

    return requestView();
  };

  return (
    <div className="changepassword">
      <Paper className="changepasswordreq_container">
        <div className={'changepasswordreq_container_title'}>
          Solicitar cambio de contraseña
        </div>
        {viewToShow()}
      </Paper>
    </div>
  );
};

export default ChangePasswordRequestView;
